import { HelpButton, Logo, ThemeToggle } from '@aulaviva/ui';
import { Link, Outlet } from 'react-router';
import { useManuale } from '@/manuale/ManualeProvider';
import { comuni, manuale } from '@/testi';

/** Accesso, registrazione, verifica: colonna centrata con il logo in alto. */
export function LayoutPubblico() {
  const { apri } = useManuale();
  return (
    <div className="min-h-dvh flex flex-col">
      <header className="contenitore flex items-center justify-between py-6">
        <Link to="/accedi" aria-label={comuni.app} className="inline-flex no-underline">
          <Logo variant="orizzontale" height={36} className="dark:hidden" />
          <Logo variant="orizzontale-negativo" height={36} className="hidden dark:block" decorative />
        </Link>
        <div className="flex items-center gap-2">
          <HelpButton label={manuale.apri} onClick={() => apri()} />
          <ThemeToggle testoChiaro={comuni.temaChiaro} testoScuro={comuni.temaScuro} />
        </div>
      </header>
      <main id="contenuto" className="contenitore flex-1 flex flex-col items-center py-8 md:py-16">
        <div className="w-full max-w-[480px] flex flex-col gap-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
